import { authenticatedFetch } from '../token';
import { config } from '../config';

export async function shareAssembly(shareable: any) {
  const resp = await authenticatedFetch(config.APIUrl + '/api/Sharing/share', 'POST', {
    shareable
  });
  return await resp.json();
}

export async function GetShareable(assemblyId: any) {
  const resp = await authenticatedFetch(config.APIUrl + '/api/Sharing/shareable?id=' + assemblyId);
  return await resp.json();
}

// TODO to adapt to communicate with the backend and then the sharing service
// export async function getSharedAssemblies(assembly: Assembly) {
//   const request = (await createAuthRequest('POST', { assembly })) as RequestInit;
//   const resp = await fetch(config.APIUrl + `/api/getSharedAssemblies/`, request);
//   return await resp.json();
// }

// Custom Components
